import { Link } from '@remix-run/react'

export default function MiniSiteFooter() {
  return (
    <footer className='pb-6 pt-8 sm:pb-3'>
      <div className='container'>
        <div className='text-xs flex flex-col items-center gap-1 text-secondary md:flex-row md:justify-center md:gap-1.5 md:space-y-0 lg:gap-3'>
          <div className='whitespace-nowrap'>
            &copy; {new Date().getFullYear()} PlanetScale Inc. All rights reserved.
          </div>

          <div className='flex justify-center gap-1 sm:justify-start'>
            <Link className='text-primary' prefetch='intent' rel='nofollow' to='/legal/privacy'>
              Privacy
            </Link>

            <Link className='text-primary' prefetch='intent' rel='nofollow' to='/legal/siteterms'>
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  )
}
